import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=0ac045eb&scoped=true&"
var script = {}
import style0 from "./Hero.vue?vue&type=style&index=0&id=0ac045eb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac045eb",
  null
  
)

export default component.exports